var map = {
	"./0/Kambi/Header.mobile.layout": [
		14704,
		1950,
		2090
	],
	"./0/Kambi/Header.pc.layout": [
		99185,
		1950,
		8425
	],
	"./0/Kambi/HomeSection.layout": [
		48995,
		1950,
		7738
	],
	"./0/Kambi/SecondaryMenu.layout": [
		8017,
		1950,
		6277
	],
	"./0/Kambi/UsefulLinks.layout": [
		71360,
		1950,
		1539
	],
	"./0/Poker/Header.mobile.layout": [
		50289,
		1950,
		3673
	],
	"./0/Poker/Header.pc.layout": [
		36984,
		1950,
		3586
	],
	"./0/Poker/HomeSection.layout": [
		63170,
		1950,
		9345
	],
	"./0/Poker/LoyaltySection.layout": [
		73189,
		1950,
		4410
	],
	"./0/Poker/SecondaryMenu.layout": [
		4131,
		1950,
		1886
	],
	"./0/Poker/UsefulLinks.layout": [
		33017,
		1950,
		6804
	],
	"./0/Spectate/Header.mobile.layout": [
		74385,
		1950,
		273
	],
	"./0/Spectate/Header.pc.layout": [
		90744,
		1950,
		8474
	],
	"./0/Spectate/HomeSection.layout": [
		86434,
		1950,
		4521
	],
	"./0/Spectate/SecondaryMenu.layout": [
		33790,
		1950,
		7894
	],
	"./0/Spectate/UsefulLinks.layout": [
		60281,
		1950,
		3212
	],
	"./1/Kambi/Header.mobile.layout": [
		80853,
		1950,
		7906
	],
	"./1/Kambi/Header.pc.layout": [
		32940,
		1950,
		5310
	],
	"./1/Kambi/HomeSection.layout": [
		94398,
		1950,
		3237
	],
	"./1/Kambi/SecondaryMenu.layout": [
		21623,
		6266
	],
	"./1/Kambi/UsefulLinks.layout": [
		35397,
		1950,
		8456
	],
	"./1/Poker/Header.mobile.layout": [
		63688,
		1950,
		7822
	],
	"./1/Poker/Header.pc.layout": [
		13289,
		1950,
		4989
	],
	"./1/Poker/HomeSection.layout": [
		51835,
		1950,
		6774
	],
	"./1/Poker/LoyaltySection.layout": [
		78502,
		1950,
		4895
	],
	"./1/Poker/SecondaryMenu.layout": [
		83330,
		1950,
		5145
	],
	"./1/Poker/UsefulLinks.layout": [
		81512,
		1950,
		7935
	],
	"./1/Spectate/Header.mobile.layout": [
		56254,
		1950,
		6118
	],
	"./1/Spectate/Header.pc.layout": [
		14763,
		1950,
		4661
	],
	"./1/Spectate/HomeSection.layout": [
		75701,
		1950,
		9086
	],
	"./1/Spectate/SecondaryMenu.layout": [
		97680,
		1950,
		2593
	],
	"./1/Spectate/UsefulLinks.layout": [
		5650,
		1950,
		327
	],
	"./31/Kambi/Header.mobile.layout": [
		27720,
		1950,
		8010
	],
	"./31/Kambi/Header.pc.layout": [
		13975,
		1950,
		535,
		4329
	],
	"./31/Kambi/HomeSection.layout": [
		90011,
		1950,
		2410
	],
	"./31/Kambi/SecondaryMenu.layout": [
		38185,
		1950,
		837
	],
	"./31/Kambi/UsefulLinks.layout": [
		19688,
		1950,
		7059
	],
	"./31/Poker/Header.mobile.layout": [
		86201,
		1950,
		895
	],
	"./31/Poker/Header.pc.layout": [
		61696,
		1950,
		2636
	],
	"./31/Poker/HomeSection.layout": [
		3786,
		1950,
		5815
	],
	"./31/Poker/LoyaltySection.layout": [
		79997,
		1950,
		612
	],
	"./31/Poker/SecondaryMenu.layout": [
		38342,
		1950,
		3272
	],
	"./31/Poker/UsefulLinks.layout": [
		99409,
		1950,
		2946
	],
	"./31/Spectate/Header.mobile.layout": [
		15881,
		1950,
		2071
	],
	"./31/Spectate/Header.pc.layout": [
		72176,
		1950,
		535,
		1716
	],
	"./31/Spectate/HomeSection.layout": [
		88570,
		1950,
		4863
	],
	"./31/Spectate/SecondaryMenu.layout": [
		78059,
		1950,
		5120
	],
	"./31/Spectate/UsefulLinks.layout": [
		42049,
		1950,
		6762
	],
	"./58/Spectate/Header.mobile.layout": [
		17948,
		1950,
		6882
	],
	"./58/Spectate/Header.pc.layout": [
		24653,
		1950,
		8529
	],
	"./58/Spectate/HistorySection.layout": [
		89832,
		1950,
		1425
	],
	"./58/Spectate/HomeSection.layout": [
		47911,
		1950,
		9426
	],
	"./58/Spectate/SecondaryMenu.layout": [
		39885,
		1950,
		5021
	],
	"./58/Spectate/UsefulLinks.layout": [
		42084,
		1950,
		267
	],
	"./75/Kambi/Header.mobile.layout": [
		33440,
		1950,
		5858
	],
	"./75/Kambi/Header.pc.layout": [
		97121,
		1950,
		7569
	],
	"./75/Kambi/HomeSection.layout": [
		62195,
		1950,
		7010
	],
	"./75/Kambi/SecondaryMenu.layout": [
		66881,
		1950,
		7645
	],
	"./75/Kambi/UsefulLinks.layout": [
		99952,
		1950,
		7851
	],
	"./75/Spectate/Header.mobile.layout": [
		23713,
		1950,
		2487
	],
	"./75/Spectate/Header.pc.layout": [
		95272,
		1950,
		6884
	],
	"./75/Spectate/HomeSection.layout": [
		62258,
		1950,
		3231
	],
	"./75/Spectate/SecondaryMenu.layout": [
		97550,
		1950,
		4208
	],
	"./75/Spectate/UsefulLinks.layout": [
		1545,
		1950,
		5354
	],
	"./76/Kambi/Header.mobile.layout": [
		78187,
		1950,
		7047
	],
	"./76/Kambi/Header.pc.layout": [
		87030,
		1950,
		5284
	],
	"./76/Kambi/HomeSection.layout": [
		32416,
		1950,
		3791
	],
	"./76/Kambi/SecondaryMenu.layout": [
		81061,
		1950,
		6288
	],
	"./76/Kambi/UsefulLinks.layout": [
		80567,
		1950,
		1306
	],
	"./76/Spectate/Header.mobile.layout": [
		21024,
		1950,
		9026
	],
	"./76/Spectate/Header.pc.layout": [
		6305,
		1950,
		4273
	],
	"./76/Spectate/HomeSection.layout": [
		94835,
		1950,
		3842
	],
	"./76/Spectate/SecondaryMenu.layout": [
		5089,
		1950,
		7517
	],
	"./76/Spectate/UsefulLinks.layout": [
		32592,
		1950,
		9867
	],
	"./8/Poker/Header.mobile.layout": [
		1209,
		1950,
		705
	],
	"./8/Poker/Header.pc.layout": [
		55808,
		1950,
		3498
	],
	"./8/Poker/HomeSection.layout": [
		13834,
		1950,
		9657
	],
	"./8/Poker/LoyaltySection.layout": [
		70333,
		1950,
		6530
	],
	"./8/Poker/SecondaryMenu.layout": [
		23323,
		1950,
		2566
	],
	"./8/Poker/UsefulLinks.layout": [
		70225,
		1950,
		9228
	],
	"./8/Spectate/Header.mobile.layout": [
		77641,
		1950,
		7609
	],
	"./8/Spectate/Header.pc.layout": [
		72784,
		1950,
		3885,
		2658
	],
	"./8/Spectate/HistorySection.layout": [
		18615,
		1950,
		2588
	],
	"./8/Spectate/HomeSection.layout": [
		83866,
		1950,
		8465
	],
	"./8/Spectate/RegulationLogosSection.layout": [
		50019,
		6080
	],
	"./8/Spectate/SecondaryMenu.layout": [
		65881,
		1950,
		8792,
		1198
	],
	"./8/Spectate/UsefulLinks.layout": [
		81377,
		1950,
		6532
	],
	"./81/Kambi/Header.mobile.layout": [
		77741,
		1950,
		8165
	],
	"./81/Kambi/Header.pc.layout": [
		32772,
		1950,
		6256,
		4510
	],
	"./81/Kambi/HomeSection.layout": [
		70646,
		1950,
		7477
	],
	"./81/Kambi/SecondaryMenu.layout": [
		68634,
		1950,
		5866
	],
	"./81/Kambi/UsefulLinks.layout": [
		20941,
		1950,
		4635
	],
	"./81/Spectate/Header.mobile.layout": [
		97334,
		1950,
		632
	],
	"./81/Spectate/Header.pc.layout": [
		18787,
		1950,
		6256,
		115
	],
	"./81/Spectate/HomeSection.layout": [
		61325,
		1950,
		3152
	],
	"./81/Spectate/SecondaryMenu.layout": [
		85447,
		1950,
		6951
	],
	"./81/Spectate/UsefulLinks.layout": [
		45146,
		1950,
		9185
	],
	"./84/Kambi/Header.mobile.layout": [
		34500,
		1950,
		2926
	],
	"./84/Kambi/Header.pc.layout": [
		43989,
		7597
	],
	"./84/Kambi/HomeSection.layout": [
		49999,
		1950,
		7062
	],
	"./84/Kambi/SecondaryMenu.layout": [
		45614,
		1950,
		249
	],
	"./84/Kambi/UsefulLinks.layout": [
		93692,
		1950,
		8223
	],
	"./84/Spectate/Header.mobile.layout": [
		89301,
		1950,
		5455
	],
	"./84/Spectate/Header.pc.layout": [
		77100,
		1950,
		5964
	],
	"./84/Spectate/HomeSection.layout": [
		26526,
		1950,
		2087
	],
	"./84/Spectate/SecondaryMenu.layout": [
		16140,
		1950,
		4040
	],
	"./84/Spectate/UsefulLinks.layout": [
		59397,
		1950,
		4466
	],
	"./86/Spectate/Header.mobile.layout": [
		57823,
		1950,
		3365
	],
	"./86/Spectate/Header.pc.layout": [
		53074,
		1950,
		296,
		2414
	],
	"./86/Spectate/HomeSection.layout": [
		72540,
		1950,
		7525
	],
	"./86/Spectate/SILinks.mobile.layout": [
		82241,
		257
	],
	"./86/Spectate/SILinks.pc.layout": [
		25160,
		7338
	],
	"./86/Spectate/SecondaryMenu.layout": [
		41529,
		1950,
		1066
	],
	"./86/Spectate/UsefulLinks.layout": [
		97683,
		1950,
		7064
	],
	"./87/Spectate/Header.mobile.layout": [
		12500,
		1950,
		989
	],
	"./87/Spectate/Header.pc.layout": [
		84741,
		1950,
		6697
	],
	"./87/Spectate/HomeSection.layout": [
		86303,
		1950,
		7114
	],
	"./87/Spectate/SecondaryMenu.layout": [
		88894,
		1950,
		6229
	],
	"./87/Spectate/UsefulLinks.layout": [
		83500,
		1950,
		8915
	],
	"./88/Spectate/Header.mobile.layout": [
		62673,
		1950,
		4315
	],
	"./88/Spectate/Header.pc.layout": [
		13656,
		1950,
		1112
	],
	"./88/Spectate/HistorySection.layout": [
		35775,
		1950,
		5034
	],
	"./88/Spectate/HomeSection.layout": [
		93218,
		1950,
		2456
	],
	"./88/Spectate/SecondaryMenu.layout": [
		93507,
		1950,
		5412
	],
	"./88/Spectate/UsefulLinks.layout": [
		61209,
		1950,
		8902
	],
	"./89/Spectate/Header.mobile.layout": [
		35006,
		1950,
		5168
	],
	"./89/Spectate/Header.pc.layout": [
		77035,
		1950,
		296,
		3467
	],
	"./89/Spectate/HomeSection.layout": [
		78389,
		1950,
		4024
	],
	"./89/Spectate/SILinks.mobile.layout": [
		54922,
		3538
	],
	"./89/Spectate/SILinks.pc.layout": [
		39143,
		4865
	],
	"./89/Spectate/SecondaryMenu.layout": [
		84560,
		1950,
		1066,
		9423
	],
	"./89/Spectate/UsefulLinks.layout": [
		85458,
		1950,
		1961
	],
	"./90/Spectate/Header.mobile.layout": [
		35608,
		1950,
		5486
	],
	"./90/Spectate/Header.pc.layout": [
		86361,
		1950,
		296,
		1453
	],
	"./90/Spectate/HomeSection.layout": [
		69707,
		1950,
		1606
	],
	"./90/Spectate/SILinks.mobile.layout": [
		19508,
		8008
	],
	"./90/Spectate/SILinks.pc.layout": [
		23109,
		4515
	],
	"./90/Spectate/SecondaryMenu.layout": [
		27186,
		1950,
		1066,
		5817
	],
	"./90/Spectate/UsefulLinks.layout": [
		1496,
		1950,
		799
	],
	"./91/Spectate/Header.mobile.layout": [
		3651,
		1950,
		7113
	],
	"./91/Spectate/Header.pc.layout": [
		39246,
		1950,
		296,
		4194
	],
	"./91/Spectate/HomeSection.layout": [
		76184,
		1950,
		5617
	],
	"./91/Spectate/LeftHeader.pc.layout": [
		77855,
		8469
	],
	"./91/Spectate/SILinks.mobile.layout": [
		26517,
		9237
	],
	"./91/Spectate/SILinks.pc.layout": [
		19404,
		1806
	],
	"./91/Spectate/SecondaryMenu.layout": [
		71917,
		1950,
		1066,
		398
	],
	"./91/Spectate/UsefulLinks.layout": [
		66399,
		1950,
		1204
	],
	"./92/Spectate/Header.mobile.layout": [
		20646,
		1950,
		4872
	],
	"./92/Spectate/Header.pc.layout": [
		85491,
		1950,
		9139
	],
	"./92/Spectate/HomeSection.layout": [
		39549,
		1950,
		4960
	],
	"./92/Spectate/LeftHeader.pc.layout": [
		56526,
		38
	],
	"./92/Spectate/SecondaryMenu.layout": [
		29860,
		1950,
		2916
	],
	"./92/Spectate/UsefulLinks.layout": [
		27818,
		1950,
		8017
	],
	"./94/Spectate/Header.mobile.layout": [
		31108,
		1950,
		2426
	],
	"./94/Spectate/Header.pc.layout": [
		94933,
		1950,
		8918
	],
	"./94/Spectate/HomeSection.layout": [
		82927,
		1950,
		2314
	],
	"./94/Spectate/LeftHeader.pc.layout": [
		58788,
		9392
	],
	"./94/Spectate/SecondaryMenu.layout": [
		58521,
		1950,
		9301
	],
	"./94/Spectate/UsefulLinks.layout": [
		37084,
		1950,
		499
	],
	"./95/Spectate/Header.mobile.layout": [
		40175,
		1950,
		2773
	],
	"./95/Spectate/Header.pc.layout": [
		86730,
		1950,
		478
	],
	"./95/Spectate/HomeSection.layout": [
		41068,
		1950,
		4181
	],
	"./95/Spectate/LeftHeader.pc.layout": [
		6139,
		2533
	],
	"./95/Spectate/SecondaryMenu.layout": [
		71636,
		1950,
		9578
	],
	"./95/Spectate/UsefulLinks.layout": [
		31235,
		1950,
		2360
	],
	"./96/Poker/Header.mobile.layout": [
		21092,
		1950,
		908
	],
	"./96/Poker/Header.pc.layout": [
		71189,
		1950,
		9447
	],
	"./96/Poker/HomeSection.layout": [
		92431,
		1950,
		8860
	],
	"./96/Poker/LoyaltySection.layout": [
		69834,
		1950,
		9929
	],
	"./96/Poker/SecondaryMenu.layout": [
		91694,
		1950,
		9800
	],
	"./96/Poker/UsefulLinks.layout": [
		26908,
		1950,
		5869
	],
	"./96/Spectate/Header.mobile.layout": [
		11170,
		1950,
		4212
	],
	"./96/Spectate/Header.pc.layout": [
		77919,
		1950,
		3885,
		111
	],
	"./96/Spectate/HistorySection.layout": [
		29590,
		1950,
		7439
	],
	"./96/Spectate/HomeSection.layout": [
		27617,
		1950,
		5636
	],
	"./96/Spectate/RegulationLogosSection.layout": [
		87218,
		8619
	],
	"./96/Spectate/SecondaryMenu.layout": [
		45780,
		1950,
		8792,
		8979
	],
	"./96/Spectate/UsefulLinks.layout": [
		90670,
		1950,
		965
	],
	"./default/Kambi/Header.mobile.layout": [
		94143,
		1950,
		8867
	],
	"./default/Kambi/Header.pc.layout": [
		33658,
		1216
	],
	"./default/Kambi/HomeSection.layout": [
		30012,
		1950,
		7315
	],
	"./default/Spectate/Header.mobile.layout": [
		55812,
		1950,
		60
	],
	"./default/Spectate/Header.pc.layout": [
		48245,
		6759
	],
	"./default/Spectate/HomeSection.layout": [
		70767,
		1950,
		2364
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95275;
module.exports = webpackAsyncContext;